export enum LeaveBalanceCalendar {
None,
Anniversary,
Calendar,
}
